
import React from 'react'

import cn from 'classnames';
import Image from 'next/legacy/image';

import I18n from '@utils/i18n';

import styles from '@styles/modules/communityTopic.module.css'

const TradeLogo = () => {
  return (
        <div className={styles.TradeLogo} data-name="trade-logo">
            <div className={styles.logoCont}>
                <div className={styles.logoContLeft}>
                    <div className={styles.kikilogo}>
                        <Image
                            className={styles.logoImage}
                            width={24}
                            height={24}
                            src={require('@images/logo4.webp')}
                            />
                        <p className={cn(styles.kikiname, 'DINPro-Medium')}>KIKI</p>
                    </div>
                    <p className={styles.logoTip}>{I18n.t('login_introduce')}</p>
                </div>
                <div>
                    <Image
                        alt=''
                        src={require('@images/downlogo.webp')}
                        width={80}
                        height={80}
                        quality={100}
                        />
                </div>
            </div>
        </div>
  )
};
export default TradeLogo
